/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Admin_Aititle1Inputs */

const zh_landing_admin_aititle1 = /** @type {(inputs: Landing_Admin_Aititle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的随身 AI 辅导老师`)
};

const en_landing_admin_aititle1 = /** @type {(inputs: Landing_Admin_Aititle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Built-in AI Tutor`)
};

const es_landing_admin_aititle1 = /** @type {(inputs: Landing_Admin_Aititle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu tutor IA integrado`)
};

/**
* | output |
* | --- |
* | "Your Built-in AI Tutor" |
*
* @param {Landing_Admin_Aititle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const landing_admin_aititle1 = /** @type {((inputs?: Landing_Admin_Aititle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Admin_Aititle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_admin_aititle1(inputs)
	if (locale === "en") return en_landing_admin_aititle1(inputs)
	return es_landing_admin_aititle1(inputs)
});
export { landing_admin_aititle1 as "landing_admin_aiTitle" }